import React, { useRef } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { useEffect } from 'react';
import axios from "axios";
import Resizer from "react-image-file-resizer";
import { ProductContext } from '../../App';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

function Edit(props) {
    const product_context = useContext(ProductContext);
    const { productType, setIsLoading } = product_context;
    const { editParams, setEditParams, sizeInp, setSizeInp } = props;
    const { isOpen, data, reload } = editParams;

    const [sizeAdded, setSizeAdded] = useState(true);

    const [image, setImage] = useState([]);

    const handleImageChange = async (e) => {
        try {
            const file = e.target.files[0];
            const resizedimage = await resizeFile(file);
            setImage([...image, resizedimage]);
            e.target.value = null;
        } catch (error) {
            product_context.setAlert({
                isOpen: true,
                message: "Something went wrong",
                type: "danger",
            });
        }
        setTimeout(() => {
            product_context.setAlert({ ...product_context.alert, isOpen: false });
        }, 5000);
    };

    const sizeRef = useRef(null);

    let size = 0;
    sizeInp.forEach(sizeInp => {
        if (sizeInp !== "") {
            size += 1;
        }
    })

    const [productDetails, setProductDetails] = useState({
        sellerName: '',
        itemType: '',
        itemName: '',
        price: '',
        color: '',
        size: sizeInp,
        additionalPrice: '',
    });

    useEffect(() => {
        setProductDetails({
            sellerName: data?.seller_name,
            itemType: data?.item_type,
            itemName: data?.item_name,
            price: data?.price,
            color: data?.color,
            size: data?.size,
            additionalPrice: data?.additional_price,
        });
        data.image ? setImage(data.image) : setImage([]);
    }, [data])

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        let temp = { ...productDetails };
        temp[name] = value;
        setProductDetails(temp);
    }

    useEffect(() => {
        sizeRef.current && sizeRef.current.focus();
    }, [sizeAdded])

    const addInputSize = () => {
        const size = [...sizeInp, []];
        setSizeInp(size);
        setSizeAdded(!sizeAdded);

    }
    const handleChangeSize = (value, i) => {
        const inputdataSize = [...sizeInp];
        inputdataSize[i] = value.target.value.toUpperCase();
        setSizeInp(inputdataSize);
    }
    const handleRemoveSize = (e, i) => {
        let deletedataSize = [...sizeInp];
        deletedataSize.splice(i, 1);
        setSizeInp(deletedataSize);
        e.preventDefault();
    }

    const handleEditSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        let seller_name = e.target.sellerName.value;
        if (!seller_name) {
            seller_name = "Dream Closet";
        }
        let edited_data = {
            seller_name: seller_name,
            item_name: e.target.itemName.value,
            item_type: e.target.itemType.value,
            price: e.target.price.value,
            color: e.target.color.value,
            size: sizeInp.filter((el) => el.trim() !== ""),
            additional_price: e.target.additionalPrice.value,
            quantity: size,
            total_in_hand: size * ((e.target.price.value * 1) + (e.target.additionalPrice.value * 1)),
            image: image,
        }

        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/products/${data._id}`, edited_data)
            .then((res) => {
                product_context.setAlert({
                    isOpen: true,
                    message: "Product Inserted",
                    type: 'success'
                });
                reload();
                setImage([]);
            })
            .catch((err) => {
                product_context.setAlert({
                    isOpen: true,
                    message: "Something went wrong",
                    type: 'danger'
                })
                setIsLoading(false);
            })
        setTimeout(() => {
            product_context.setAlert({ ...product_context.alert, isOpen: false })
        }, 5000);
        setEditParams({ ...editParams, isOpen: false });
        document.body.classList.remove('remove-scroll');
    }


    return (
        <>
            {isOpen ? <>
                <div className="back">

                    <div className="edit-container flex-column">
                        <h2>Edit</h2>
                        <div className="edit-form">
                            <form onSubmit={handleEditSubmit}>
                                <div className="overflow-handle">
                                    <div className="inputs">
                                        <label htmlFor="sellerName">Seller Name</label>
                                        <input type="text"
                                            value={productDetails.sellerName}
                                            placeholder='Enter Seller Name' name='sellerName'
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="itemType">Item Type</label>
                                        <select className="form-select" value={productDetails.itemType} name='itemType' onChange={handleInputChange} aria-label="Default select example">
                                            {productType.map((type, i) => {
                                                return productDetails.itemType === type ?
                                                    <option defaultChecked key={i} value={type}>{type}</option> : <option key={i} value={type}>{type}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="itemName">Item Name</label>
                                        <input type="text"
                                            value={productDetails.itemName}
                                            placeholder='Enter Item Name' name='itemName'
                                            onChange={handleInputChange} />
                                    </div>

                                    <div className="inputs">
                                        <label htmlFor="color">Color</label>
                                        <input type="text"
                                            value={productDetails.color}
                                            placeholder='Enter Color' name='color'
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="price">Price</label>
                                        <input type="number"
                                            value={productDetails.price}
                                            placeholder='Enter Price' name='price'
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="additionalPrice">Additional Price</label>
                                        <input type="number"
                                            value={productDetails.additionalPrice}
                                            placeholder='Enter Additional Price' name='additionalPrice'
                                            onChange={handleInputChange} />
                                    </div>
                                    <div className="inputs">
                                        <label htmlFor="image">Image</label>
                                        <div className="d-flex">
                                            {image.map((img, i) => {
                                                return (
                                                    <div key={i} className="show-image mx-3">
                                                        <CloseIcon
                                                            onClick={(e) => {
                                                                let deletedimg = [...image];
                                                                deletedimg.splice(i, 1);
                                                                setImage(deletedimg);
                                                                e.preventDefault();
                                                            }}
                                                            className="fa-solid fa-xmark"
                                                        ></CloseIcon>
                                                        <img className="edit-image" src={img} alt="..." />
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <input
                                            placeholder='Select Image'
                                            onChange={(e) => {
                                                handleImageChange(e);
                                            }}
                                            type="file" name="image" accept='.jpg, .jpeg, .png, .heic, .HEIC' />
                                    </div>
                                    <div className="inputs small">
                                        <label htmlFor="size">Size</label>
                                        <div id="sizes" className='d-flex'>
                                            {sizeInp?.map((size, i) => {
                                                return (
                                                    <div className='list' key={i}>
                                                        <input ref={sizeRef} className='mt-2' placeholder='Size' type="text" key={i} value={size} onChange={e => handleChangeSize(e, i)} />
                                                        <CloseIcon className='fa-solid fa-trash remove-button' onClick={(e) => handleRemoveSize(e, i)}></CloseIcon>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <AddIcon className="fa-solid fa-plus add-button" onClick={() => addInputSize()} ></AddIcon>
                                    </div>
                                </div>
                                <div className="">
                                    <button type='submit' className="btn btn-success me-2">Submit</button>
                                    <button type="button" className='btn btn-danger ms-2' onClick={() => {
                                        setEditParams({ ...editParams, data: {}, isOpen: false });
                                        setImage([]);
                                        document.body.classList.remove('remove-scroll');
                                    }} >Close</button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>

            </> : null}
        </>
    )
}

export default Edit;

const resizeFile = (file) =>
    new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            200,
            200,
            "JPEG",
            70,
            0,
            (uri) => {
                resolve(uri);
            },
            "base64"
        );
    });